import type { IconProps } from '../types/IconProps.ts';
export const SlidersHorizontal: IconProps = {
    name: 'SlidersHorizontal',
    children: [
        `<path d="M3 5h7M14 5V3m0 2v2m0-2h7M8 12v-2m0 2v2m0-2H3M12 12h9M3 19h9M16 19v-2m0 2v2m0-2h5" />`,
    ]
};